import {FC, memo} from 'react';
import {BlockTitle} from 'modules/wineshops-list/components/BlockTitle';
import {Typography} from 'components/Typography';
import style from './style.module.scss';
import dynamic from 'next/dynamic';
import {IWineShop} from 'modules/wineshops-list/models';

const MapBox = dynamic(
    () =>
        import('modules/map/components/Map').then((m) => ({
            default: m.MapBox,
        })),
    {ssr: false, loading: () => <div className={style.map} />},
);

interface IProps {
    essentials?: string;
    data: IWineShop;
}

export interface IWineShopLocationProps {
    code: string;
    id: number;
    latitude: string;
    longitude: string;
    name: string;
    title: string;
}

export const WineShopLocation: FC<IProps> = memo(({essentials, data}) => {
    const {title} = data || {};

    return (
        <div className={style.locationWrapper}>
            <BlockTitle>
                <Typography element={'h2'} variant={'headline-32-m'}>
                    {`${title} на карте`}
                </Typography>
            </BlockTitle>
            <MapBox className={style.map} data={[data]} initialZoom={17} isMarkerPopupAvailable={false} />
            {essentials && (
                <>
                    <Typography className={style.essentialsTitle} color={'gray60'} element={'div'}>
                        Реквизиты:
                    </Typography>
                    <div className={style.essentialsText}>{essentials}</div>
                </>
            )}
        </div>
    );
});
